import React from 'react';
import { Paper, Grid, FormControl, InputLabel, Select, MenuItem, Button, TextField } from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';
import type { PayoutInvoiceFiltersState } from '../hooks/usePayoutInvoices';
import type { Trader } from '@/types/trader';
import { PAYOUT_INVOICE_STATUSES, PAYOUT_INVOICE_STATUS_LABELS } from '../constants';
import SearchableSelect from '@/components/SearchableSelect';

interface PayoutInvoiceFiltersProps {
  filters: PayoutInvoiceFiltersState;
  traders: Trader[];
  onFilterChange: (field: keyof PayoutInvoiceFiltersState, value: unknown) => void;
  onSearch: () => void;
  onReset: () => void;
}

const PayoutInvoiceFilters: React.FC<PayoutInvoiceFiltersProps> = ({
  filters,
  traders,
  onFilterChange,
  onSearch,
  onReset,
}) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel>Статус</InputLabel>
            <Select
              value={filters.status}
              label="Статус"
              onChange={(e) => onFilterChange('status', e.target.value)}
            >
              <MenuItem value="">Все</MenuItem>
              {PAYOUT_INVOICE_STATUSES.map((status) => (
                <MenuItem key={status} value={status}>
                  {PAYOUT_INVOICE_STATUS_LABELS[status]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <SearchableSelect
            label="Трейдер"
            value={filters.trader_id}
            options={traders.map((trader) => ({ id: trader.id, label: trader.name }))}
            onChange={(value) => onFilterChange('trader_id', value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="ID выплаты"
            value={filters.payout_id}
            onChange={(e) => onFilterChange('payout_id', e.target.value)}
          />
        </Grid>
        <Grid item xs={6} sm={3} md={1.5}>
          <Button variant="outlined" onClick={onSearch} fullWidth sx={{ height: '56px' }}>
            Применить
          </Button>
        </Grid>
        <Grid item xs={6} sm={3} md={1.5}>
          <Button
            variant="outlined"
            onClick={onReset}
            startIcon={<ClearIcon />}
            fullWidth
            sx={{ height: '56px' }}
          >
            Сбросить
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default PayoutInvoiceFilters;
